import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/psj-nuxt/psj-nuxt/app/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/home/runner/work/psj-nuxt/psj-nuxt/app/layouts/home.vue").then(m => m.default || m))
}